"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.clientImportCommitSchema = void 0;
const zod_1 = require("zod");
/**
 * `POST /clients/import` body: `companyId` is re-validated and forced
 * server-side (the client array's own `companyId` fields are never trusted —
 * see ClientsImportService.commitImport), `clients` are the `client` payloads
 * copied verbatim from the preview rows the user chose to keep.
 *
 * `clients` is deliberately validated as loose records here, NOT as
 * `createClientSchema` per element: a single malformed/tampered entry must
 * come back as one `failed` row in the `ImportResult` (so the caller can see
 * exactly which row and why), not reject the ENTIRE batch with one blanket
 * 400 before any row is processed. The authoritative per-client validation
 * (full `createClientSchema.safeParse`, with `companyId` forced) happens
 * server-side in `ClientsImportService.commitImport`.
 */
exports.clientImportCommitSchema = zod_1.z.object({
    companyId: zod_1.z.uuid('companyId invalid.'),
    clients: zod_1.z.array(zod_1.z.record(zod_1.z.string(), zod_1.z.unknown())).max(1000, 'Prea mulți clienți într-o singură cerere.'),
});
